// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__z1fOW","log":"ModalInventoryLogs_log__2VUgE","date":"ModalInventoryLogs_date__2YZt_","userName":"ModalInventoryLogs_userName__18Jmh"};